import * as Yup from 'yup'

export const getInitialValues = editItem => ({
  store: editItem
    ? {
        label: `${editItem.name} - ${editItem.address}`,
        value: editItem.id,
        locationName: editItem.address,
        storeCode: getMetiCode(editItem),
        storeType: editItem.type
      }
    : {
        label: '',
        value: '',
        locationName: '',
        storeCode: '',
        storeType: ''
      },
  isEnabled: editItem?.isEnabled ?? true
})

export const getValidationSchema = () =>
  Yup.object().shape({
    store: Yup.object()
      .shape({
        value: Yup.number().required('Store is required'),
        label: Yup.string().required('Store is required')
      })
      .required('Store is required'),
    isEnabled: Yup.boolean().required('Status is required')
  })

export const getMetiCode = location => {
  const { externalIdList } = location
  if (externalIdList && externalIdList.length) {
    const metiCode = externalIdList.find(id => id.system.name === 'METI')
    return metiCode ? metiCode.value : ''
  }
  return ''
}
